<script>
  import { onMount } from "svelte"
  import { tweened } from "svelte/motion"
  import { cubicOut } from "svelte/easing"

  export let score = 0

  const scoreAnimado = tweened(0, { duration: 1200, easing: cubicOut })
  let montado = false

  onMount(() => {
    montado = true
  })

  const rangos = [
    { inicio: 0, fin: 479.5, color: "#f43f50" },
    { inicio: 479.5, fin: 599.5, color: "#ff8516" },
    { inicio: 599.5, fin: 719.5, color: "#f4c526" },
    { inicio: 719.5, fin: 879.5, color: "#89b541" },
    { inicio: 879.5, fin: 999, color: "#0da455" },
  ]

  const punto = (valor) => {
    const angulo = Math.PI * (1 - valor / 999)
    return {
      x: 151 + 114 * Math.cos(angulo),
      y: 146 - 114 * Math.sin(angulo),
    }
  }

  const arco = (inicio, fin) => {
    const desde = punto(inicio)
    const hasta = punto(fin)
    return `M ${desde.x} ${desde.y} A 114 114 0 0 1 ${hasta.x} ${hasta.y}`
  }

  $: valor = Number.isFinite(Number(score)) ? Number(score) : 0
  $: disponible = valor >= 1 && valor <= 999

  $: if (montado) {
    scoreAnimado.set(disponible ? valor : 0)
  }

  $: marcador = punto($scoreAnimado)
</script>

<div class="score">
  <svg
    viewBox="0 0 290 176"
    role="img"
    aria-label={disponible ? `Score: ${valor} de 999` : "Score no disponible"}
  >
    {#each rangos as rango, indice}
      <path
        d={arco(
          rango.inicio + (indice === 0 ? 0 : 2),
          rango.fin - (indice === rangos.length - 1 ? 0 : 2),
        )}
        fill="none"
        stroke={rango.color}
        stroke-width="14"
      />
    {/each}
    {#if disponible}
      <circle
        cx={marcador.x}
        cy={marcador.y}
        r="8.5"
        fill="white"
        stroke="currentColor"
        stroke-width="3"
      />
    {/if}
    <text x="151" y="129" text-anchor="middle" class="value">
      {disponible ? Math.round($scoreAnimado) : "—"}
    </text>
    <text x="151" y="160" text-anchor="middle" class="label">de 999</text>
  </svg>
</div>

<style>
  .score {
    width: 200px;
    max-width: 260px;
    color: #283749;
  }

  svg {
    display: block;
    width: 100%;
    height: auto;
    font-family: Arial, sans-serif;
  }

  .value {
    fill: currentColor;
    font-size: 44px;
    font-weight: 400;
    font-variant-numeric: tabular-nums;
  }

  .label {
    fill: #7b889b;
    font-size: 16px;
    font-weight: 400;
  }
</style>
